// Which shell and route list the app mounts (shell-ia §17; SPEC §3.2 "Legacy flag"). One module reads the flag, so the router, the layouts
// and the e2e checks agree. WP-SHELL.
//
//   VITE_SHELL=econic   (the default, also when unset)  EconicShell with the routes of app/routes.tsx
//   VITE_SHELL=os                                      the 11 Oct Agentic OS frame with its frozen routes (app/routes.legacy.tsx)
//   VITE_SHELL=legacy   (or VITE_LEGACY_SHELL=1)        the pre-OS workspace shell with the old home page (same frozen routes)
//
// The os and legacy values are rollbacks until 22 Oct and are deleted on 29 Oct. No flag restores persona sign-in: `/login` is the strict
// sign-in under every value.

export type ShellFlag = "econic" | "os" | "legacy";

function readFlag(): ShellFlag {
  const env = import.meta.env as Record<string, string | undefined>;
  const flag = String(env.VITE_SHELL ?? "").trim().toLowerCase();
  if (flag === "os" || flag === "legacy" || flag === "econic") return flag;
  return env.VITE_LEGACY_SHELL === "1" ? "legacy" : "econic";
}

export const SHELL: ShellFlag = readFlag();
/** The pre-OS shell (kept name: `layouts.tsx` and older imports read it). */
export const LEGACY_SHELL = SHELL === "legacy";
